import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ProyectoService } from 'src/app/services/proyecto.service';

@Component({
  selector: 'app-factor-calidad',
  templateUrl: './factor-calidad.component.html',
  styleUrls: ['./factor-calidad.component.scss']
})
export class FactorCalidadComponent implements OnInit {
  factoresDeCalidad: any[] = [];
  public displayedColumnsFactorC: string[] = ['calidad', 'factor', 'uso'];


  constructor(
    private _proyectoService: ProyectoService,
    public dialogRef: MatDialogRef<FactorCalidadComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
    this.getAllFactorCalidad(0);
  }

  getAllFactorCalidad(idFactor: number): void {
    this._proyectoService.getAllFactorCalidad(idFactor).subscribe(
      (response: any) => {
        this.factoresDeCalidad = response.data;
      },
      (error) => {
        console.error('Error al obtener los factores de calidad', error);
      }
    );
  }

  closeDialog(): void {
    this.dialogRef.close();
  }
}
